export default "__VITE_ASSET__EGss8UtS__"